import axios from "axios";
import { Attraction } from "redmond";
import { config } from "../../config";
import { experiencesAttractionApiPrefix } from "../paths";

export interface GetAttractionRequest {
  attractionId: number;
}

export interface GetAttractionResponse {
  attraction?: Attraction;
}

export const fetchAttraction = async (
  attractionId: number
): Promise<Attraction | undefined> => {
  const body: GetAttractionRequest = { attractionId };
  const res = await axios.post<{ value: GetAttractionResponse }>(
    experiencesAttractionApiPrefix,
    body,
    {
      baseURL: config.baseURL,
    }
  );

  return res.data.value.attraction;
};
